import classNames from "classnames";

const mapKeys = (obj, keyFn) =>
  Object.entries(obj).reduce(
    (acc, [objKey, objValue]) => ({...acc, [keyFn(objKey)]: objValue}),
    {}
  );

export const bemBuilder = (block, ...elements) => {
  const renderClass = (element) => (block ? `${block}__${element}` : element);

  const applyBEMToElementObject = (elementObject) =>
    mapKeys(elementObject, renderClass);

  const applyBEM = (elementClasses) =>
    elementClasses.map((elementClass) => {
      if (Array.isArray(elementClass)) {
        return applyBEM(elementClass);
      }
      if (typeof elementClass === "object") {
        return applyBEMToElementObject(elementClass);
      }
      return renderClass(elementClass);
    });

  return classNames(applyBEM(elements));
};

/**
 * adds Stitch approved BEM classnames to a component.
 * @param {...string} blocks - the block section of a BEM className, in block__element--modifier
 * @returns {function(...string[]|Object|string)} - just like the classNames function, but will create classNames for all blocks
 ): string} - the returned function
 */
const classNameBuilder = (...blocks) => (...elements) =>
  blocks
    .filter((block) => block)
    .map((block) => bemBuilder(block, elements))
    .join(" ") || undefined;

export default classNameBuilder;
